module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAAJ0lEQVRIx2NgUJiPB/3HC75oOeJBDKNGjxo9avSo0aNGjxo9FI0GAO/d/UarnEBsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/fr.png
// module id = 282
// module chunks = 0